import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardContent, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, CircularProgress, Button,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Chip,
} from '@mui/material';
import { Add, Refresh } from '@mui/icons-material';
import { InvokeApi, apiList } from '../../services/ApiService';
import { Config } from '../../config/Config';
import dayjs from 'dayjs';

export default function Holidays() {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialog, setDialog] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ title: '', date: '', details: '' });

  const load = async () => {
    setLoading(true);
    const data = await InvokeApi(Config.main_url + apiList.getHolidays, {});
    setHolidays(data?.holidays || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.title || !form.date) { alert('Title and date are required'); return; }
    setSaving(true);
    const data = await InvokeApi(Config.main_url + apiList.addHoliday, {
      title: form.title,
      date: form.date,
      details: form.details || '',
    });
    setSaving(false);
    if (data?.code === '200') { setDialog(false); setForm({ title: '', date: '', details: '' }); load(); }
    else alert(data?.message || 'Failed to add holiday');
  };

  const f = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5" fontWeight={800} color="#1a237e">Holidays</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" startIcon={<Refresh />} onClick={load} sx={{ borderRadius: 2, color: '#1a237e', borderColor: '#1a237e' }}>Refresh</Button>
          <Button variant="contained" startIcon={<Add />} onClick={() => setDialog(true)}
            sx={{ background: 'linear-gradient(135deg,#1a237e,#1565c0)', borderRadius: 2, fontWeight: 700 }}>Add Holiday</Button>
        </Box>
      </Box>

      <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}><CircularProgress sx={{ color: '#1a237e' }} /></Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ background: '#f5f6fa' }}>
                  {['#', 'Title', 'Date', 'Day', 'Details'].map(h => (
                    <TableCell key={h} sx={{ fontWeight: 700, color: '#1a237e', fontSize: 13 }}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {holidays.length === 0 ? (
                  <TableRow><TableCell colSpan={5} align="center" sx={{ py: 4, color: 'text.secondary' }}>No holidays found</TableCell></TableRow>
                ) : holidays.map((h, i) => (
                  <TableRow key={h.ID || i} hover>
                    <TableCell sx={{ fontSize: 13, color: 'text.secondary' }}>{i + 1}</TableCell>
                    <TableCell sx={{ fontSize: 13, fontWeight: 600 }}>{h.title}</TableCell>
                    <TableCell sx={{ fontSize: 13 }}>{h.date ? dayjs(h.date).format('DD MMM YYYY') : '—'}</TableCell>
                    <TableCell>{h.date ? <Chip label={dayjs(h.date).format('dddd')} size="small" sx={{ background: '#e8eaf6', color: '#1a237e', fontWeight: 600, fontSize: 11 }} /> : '—'}</TableCell>
                    <TableCell sx={{ fontSize: 13, color: 'text.secondary' }}>{h.details || '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Card>

      <Dialog open={dialog} onClose={() => setDialog(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 700, color: '#1a237e' }}>Add Holiday</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ pt: 1 }}>
            <Grid item xs={12}><TextField fullWidth size="small" label="Holiday Title *" value={form.title} onChange={f('title')} /></Grid>
            <Grid item xs={12}><TextField fullWidth size="small" type="date" label="Date *" value={form.date} onChange={f('date')} InputLabelProps={{ shrink: true }} /></Grid>
            <Grid item xs={12}><TextField fullWidth size="small" label="Details (optional)" value={form.details} onChange={f('details')} multiline rows={2} /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button onClick={() => setDialog(false)} variant="outlined" sx={{ borderRadius: 2 }}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={saving}
            sx={{ background: 'linear-gradient(135deg,#1a237e,#1565c0)', borderRadius: 2, fontWeight: 700 }}>
            {saving ? <CircularProgress size={20} color="inherit" /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
